import { render, staticRenderFns } from "./age-check-popup.vue?vue&type=template&id=1fdc6c48&"
import script from "./age-check-popup.vue?vue&type=script&lang=js&"
export * from "./age-check-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports